import {enumToArray, enumToObjectArray} from "../functions/functions";

export enum UserTypesEnum {
  CIT = 'CIT',
  INST = 'INST',
  POPSM = 'POPSM',
  Executive = 'Executive'
}

export enum CrossBoarderEnum {
  pesa = 'PESA',
  jobseeker = 'JOBSEEKER',
  employer = 'EMPLOYER',
  specialGroupOrArtist = "SPECIALGROUP"
}

export const USER_TYPES_OBJ = enumToObjectArray(UserTypesEnum)
export const USER_TYPES = enumToArray(UserTypesEnum)

